import { useMemo } from 'react';
import { useTranslation } from './useTranslation';
import { createPlaceholderResolver } from '@constants/placeholders';

// Memoized { tokens, getLabel } pair for the given placeholder context. The pair is stable as
// long as the active translator function doesn't change, so it can be passed to
// serializePlaceholdersToHtml without triggering downstream re-renders.
export const usePlaceholderResolver = context => {
    const { t } = useTranslation();
    return useMemo(() => createPlaceholderResolver(t, context), [t, context]);
};
